import React, { useState, useEffect } from 'react';
import { withRouter } from '../../common/withRouter';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  DataDefinitionList,
  Notification,
  ButtonOBSOLETED
} from '../../web.common';
import withApi from '../higherOrderComponents/withApi';
import { LayoutContext } from '../layout/siteLayout';
import PageTop from '../layout/PageTop';
import {
  DisplayGuid,
  DisplayDate} from '../items';
import ReactSelect from 'react-select';

const RelayRuleInternal = ({
  api,
  match: {
    params: { ruleId }
  },
  history
}) => {

  const [data, setData] = useState(null);
  const [isEditing, doEdit] = useState(null);

  const formLabelStyle = {
    display: "table-cell",
    width: "20%",
    whiteSpace: "nowrap",
    fontWeight: "bold",
    verticalAlign: "top"
  };

  const formSpanStyle = {
    display: "table-cell",
  };

  const rowStyle = {
    display: "table",
    width: "100%",
    margin: "auto",
    marginBottom: "0"
  };

  const containerStyle = {
    width: '80%',
    margin: 'auto',
    backgroundColor: 'white',
    border: "1px solid #e5e5e5",
    padding: "1.2rem"
  };

  const textAreaStyle = {
    width: '100%'
  };

  const relayTypeMappings = [
    { value: 1, label: "BadInfo" },
    { value: 2, label: "Parse" },
    { value: 4, label: "Irrelevant" },
    { value: 8, label: "IsSignup" },
    { value: 16, label: "IsCancellation" },
    { value: 32, label: "Warning" },
  ];

  const getType = (typeFlag) => {
    const result = relayTypeMappings.find(item => item.value === typeFlag);
    if (result == null || result == undefined) {
      return "";
    }
    return result.label;
  }

  useEffect(() => {
    async function loadFromApi() {
      const rule = await api.relayRules.getRuleById(ruleId);
      setData(rule);
    }

    if (!data) {
      loadFromApi();
    }
  }, []);

  return (
    <LayoutContext.Consumer>
      {() => (
        <React.Fragment>
          <Notification newMessage={"boh"} />
          <PageTop
            documentTitle={`Relay rule page`}
            documentDescription={`Relay rule page`}
          />
          {
            data ?
              (<React.Fragment>
                <br />
                <br />
                <br />
                <h3>Relay Rule</h3>
                {
                  isEditing ?
                    <React.Fragment>
                      <div style={containerStyle}>
                        <div style={rowStyle}>
                          <label for="name" style={formLabelStyle}>Name</label>
                          <span style={formSpanStyle} >
                            <input name="name" id="name"
                              value={isEditing.name}
                              onChange={({ target }) => doEdit({ ...isEditing, name: console.log(target.value) || target.value })} />
                          </span>
                        </div>
                        <hr />
                        <div style={rowStyle}>
                          <label for="primary" style={formLabelStyle}>Primary</label>
                          <span style={formSpanStyle} >
                            <textarea style={textAreaStyle} name="primary" id="primary"
                              placeholder='primary'
                              value={isEditing.primary}
                              onChange={({ target }) => doEdit({ ...isEditing, primary: console.log(target.value) || target.value })} >
                            </textarea>
                          </span>
                        </div>
                        <hr />
                        <div style={rowStyle}>
                          <label for="facility" style={formLabelStyle}>Facility</label>
                          <span style={formSpanStyle} >
                            <textarea style={textAreaStyle} name="facility" id="facility"
                              placeholder='facility'
                              value={isEditing.facility}
                              onChange={({ target }) => doEdit({ ...isEditing, facility: console.log(target.value) || target.value })} >
                            </textarea>
                          </span>
                        </div>
                        <hr />
                        <div style={rowStyle}>
                          <label for="title" style={formLabelStyle}>Title</label>
                          <span style={formSpanStyle} >
                            <textarea style={textAreaStyle} name="title" id="title"
                              value={isEditing.title}
                              onChange={({ target }) => doEdit({ ...isEditing, title: console.log(target.value) || target.value })} >
                            </textarea>
                          </span>
                        </div>
                        <hr />
                        <div style={rowStyle}>
                          <label for="day" style={formLabelStyle}>Day</label>
                          <span style={formSpanStyle} >
                            <textarea style={textAreaStyle} name="day" id="day"
                              value={isEditing.day}
                              onChange={({ target }) => doEdit({ ...isEditing, day: console.log(target.value) || target.value })} >
                            </textarea>
                          </span>
                        </div>
                        <hr />
                        <div style={rowStyle}>
                          <label for="month" style={formLabelStyle}>Month</label>
                          <span style={formSpanStyle} >
                            <textarea style={textAreaStyle} name="month" id="month"
                              value={isEditing.month}
                              onChange={({ target }) => doEdit({ ...isEditing, month: console.log(target.value) || target.value })} >
                            </textarea>
                          </span>
                        </div>
                        <hr />
                        <div style={rowStyle}>
                          <label for="year" style={formLabelStyle}>Year</label>
                          <span style={formSpanStyle} >
                            <textarea style={textAreaStyle} name="year" id="year"
                              value={isEditing.year}
                              onChange={({ target }) => doEdit({ ...isEditing, year: console.log(target.value) || target.value })} >
                            </textarea>
                          </span>
                        </div>
                        <hr />
                        <div style={rowStyle}>
                          <label for="start" style={formLabelStyle}>Start</label>
                          <span style={formSpanStyle} >
                            <textarea style={textAreaStyle} name="start" id="start"
                              value={isEditing.start}
                              onChange={({ target }) => doEdit({ ...isEditing, start: console.log(target.value) || target.value })} >
                            </textarea>
                          </span>
                        </div>
                        <hr />
                        <div style={rowStyle}>
                          <label for="end" style={formLabelStyle}>End</label>
                          <span style={formSpanStyle} >
                            <textarea style={textAreaStyle} name="end" id="end"
                              value={isEditing.end}
                              onChange={({ target }) => doEdit({ ...isEditing, end: console.log(target.value) || target.value })} >
                            </textarea>
                          </span>
                        </div>
                        <hr />
                        <div style={rowStyle}>
                          <label for="duration" style={formLabelStyle}>Duration</label>
                          <span style={formSpanStyle} >
                            <textarea style={textAreaStyle} name="duration" id="duration"
                              value={isEditing.duration}
                              onChange={({ target }) => doEdit({ ...isEditing, duration: console.log(target.value) || target.value })} >
                            </textarea>
                          </span>
                        </div>
                        <hr />
                        <div style={rowStyle}>
                          <label for="accessCode" style={formLabelStyle}>AccessCode</label>
                          <span style={formSpanStyle} >
                            <textarea style={textAreaStyle} name="accessCode" id="accessCode"
                              value={isEditing.accessCode}
                              onChange={({ target }) => doEdit({ ...isEditing, accessCode: console.log(target.value) || target.value })} >
                            </textarea>
                          </span>
                        </div>
                        <hr />
                        <div style={rowStyle}>
                          <label for="externalId" style={formLabelStyle}>ExternalId</label>
                          <span style={formSpanStyle} >
                            <textarea style={textAreaStyle} name="externalId" id="externalId"
                              value={isEditing.externalId}
                              onChange={({ target }) => doEdit({ ...isEditing, externalId: console.log(target.value) || target.value })} >
                            </textarea>
                          </span>
                        </div>
                        <hr />
                        <div style={rowStyle}>
                          <label for="order" style={formLabelStyle}>Order</label>
                          <span style={formSpanStyle} >
                            <input name="order" id="order" type='number'
                              value={isEditing.order}
                              onChange={({ target }) => doEdit({ ...isEditing, order: console.log(target.value) || target.value })} />
                          </span>
                        </div>
                        <hr />
                        <div style={rowStyle}>
                          <label for="type" style={formLabelStyle}>Type</label>
                          <span style={formSpanStyle} >
                            <ReactSelect
                              className='react-select-filters-section'
                              classNamePrefix='react-select-filters-section-prefix'
                              value={relayTypeMappings.filter(x => x.value === isEditing.type) || ""}
                              onChange={(selection) => doEdit({ ...isEditing, type: console.log(selection.value) || selection.value })}
                              options={relayTypeMappings}
                            >
                            </ReactSelect>
                          </span>
                        </div>
                        <br />
                        <br />
                        <div style={{ justifyContent: 'center', display: 'flex', gap: '1.5rem' }}>
                          <ButtonOBSOLETED
                            type="submit"
                            buttonContent="Save"
                            onClick={async () => {
                              await api.relayRules.updateRule(isEditing);
                              const rule = await api.relayRules.getRuleById(isEditing.id);
                              setData(rule);
                              doEdit(null);
                            }} />
                             <ButtonOBSOLETED
                            type="reset"
                            buttonContent="Cancel"
                            onClick={async () => {
                              doEdit(null);
                            }} />
                        </div>
                      </div>
                    </React.Fragment> :
                    <DataDefinitionList
                      listData={{
                        Id: data.id,
                        Name: data.name,
                        CreatedAt: <DisplayDate>{data.createdDate}</DisplayDate>,
                        Primary: data.primary,
                        Facility: data.facility,
                        Title: data.title,
                        Day: data.day,
                        Month: data.month,
                        Year: data.year,
                        Start: data.start,
                        End: data.end,
                        Duration: data.duration,
                        AccessCode: data.accessCode,
                        ExternalId: data.externalId,
                        Order: data.order,
                        Type: getType(data.type),
                        RelatedIntegrations: <>{data.relatedIntegrations.map(({ integrationId }) => {
                          return (
                            <>
                              <DisplayGuid key={integrationId}>{integrationId}</DisplayGuid>{" "}
                            </>
                          )
                        })}</>,
                        '':
                          (<div>
                            <br />
                            <ButtonOBSOLETED
                              type="submit"
                              buttonContent="Edit"
                              onClick={() => {
                                doEdit(data);
                              }} />
                          </div>)
                      }
                      }
                      classNames={['detail-page-list']}
                    />
                }
              </React.Fragment>) :
              '..loading...'
          }

        </React.Fragment>)
      }
    </LayoutContext.Consumer>);
}

const RelayRule = withRouter(withApi(
  connect(({ user, categories }) => ({ isLoggedIn: !!user, categories }), {})(RelayRuleInternal)
));

RelayRule.requiresLogin = true;
RelayRule.propTypes = { isLoggedIn: PropTypes.bool };

export default RelayRule;